import type { ProductMediaItem } from '../types'

// PE-1283 §7 E4 — serialize the product-level media gallery into the BFF media[]
// contract: { url, type, posterUrl?, mimeType?, sortOrder, status }.
//
// - Only persisted (uploaded) items are emitted — placeholders mid-upload
//   (mediaId === null, still showing a local preview) and FAILED items are dropped.
// - A still-PROCESSING video is allowed through with status:'PROCESSING' so the
//   merchant can submit non-blocking; the storefront/poll resolves the webm later.
// - sortOrder is re-derived from final position to stay contiguous.

export interface SerializedProductMedia {
  url: string
  type: 'IMAGE' | 'VIDEO'
  posterUrl?: string
  sortOrder: number
  status: 'READY' | 'PROCESSING'
}

export const serializeProductMedia = (
  media: ProductMediaItem[] | undefined,
): SerializedProductMedia[] => {
  if (!media || media.length === 0) return []
  return media
    .filter((m) => m.mediaId !== null && m.status !== 'FAILED' && !m._previewUrl)
    .map((m, index) => ({
      url: m.url,
      type: m.type,
      ...(m.posterUrl ? { posterUrl: m.posterUrl } : {}),
      sortOrder: index,
      status: m.status === 'PROCESSING' ? ('PROCESSING' as const) : ('READY' as const),
    }))
}
